<template>
	<input
		class="room-code-input border-m input-dark"
		type="input"
		minlength="4"
		maxlength="4"
		autocomplete="off"
		required
		:value="modelValue"
		@input="updateValue"
	/>
</template>

<script>
export default {
	props: ["modelValue"],
	methods: {
		updateValue(e) {
			this.$emit("update:modelValue", e.target.value);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/input.scss";

input {
	&.room-code-input {
		text-align: center;
		padding: 0.625em 0;
		font-size: 1.25em;
		letter-spacing: 1.25em;
	}
}
</style>
